import { QueryClient } from "react-query";
import { toast } from "react-toastify";
import { isString } from "lodash";
import { generalStore } from "../stores/userStore";
import { isSessionTerminatedError } from "../utils/authErrors";

export const queryErrorHandler = (error) => {
  const setHideLoading = generalStore.getState().setHideLoading;

  if (
    error?.response?.status === 409 &&
    error.response.data?.code === "ACTIVE_SESSION"
  ) {
    return;
  }

  if (isSessionTerminatedError(error)) {
    return;
  }

  const msg =
    error instanceof Error
      ? error.response?.data &&
        (isString(error.response.data) ||
          isString(error.response.data?.Message))
        ? isString(error.response.data)
          ? error.response.data
          : error.response.data?.Message
        : error.message
      : "error connecting to server";
  toast(msg);
  setHideLoading(true);
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      onError: queryErrorHandler,
      //         staleTime: 600000, // 10 minutes
      //         cacheTime: 900000, // default cacheTime is 5 minutes; doesn't make sense for staleTime to exceed cacheTime
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
    mutations: {
      onError: queryErrorHandler,
    },
  },
});
